<template lang="html">

  <section class="banner-denominacion column-center animation" :style="`background-image:url('/static/img/productos/${data}/banner-denominacion.jpg')`">
    <div class="container textos row-between">

      <h2 class="title -ghost" v-html="$t(`productos.${data}.banner_denominacion.titulo`)"></h2>   

      <div class="denominacion column-center">

        <div class="contenedor-imagen">
          <img :src="'/static/img/productos/'+data+'/logo-denominacion.png'" alt="" >
        </div>

        <div class="denominacion-info">
          <p>{{$t(`productos.${data}.banner_denominacion.cuerpo`)}}</p>
        </div>
        
      </div>   


    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'banner-denominacion',
    props : ['data']
  }
</script>

<style scoped lang="scss">


  .banner-denominacion {
    padding: 50px 0;
    height: 390px;
  background-size: cover;
    

    .textos{
      position: relative;
      -webkit-flex-wrap: nowrap;
      -moz-flex-wrap: nowrap;
      -ms-flex-wrap: nowrap;
      -o-flex-wrap: nowrap;
      flex-wrap: nowrap;
    }

    .-ghost{
      position: absolute;
      top: -144px;
    }

    .denominacion{
      width: 100%;

      .contenedor-imagen{
        width: 160px;
       height: 160px;
        margin-bottom: 10px;
        transform: translateY(300px);
        opacity: 0;
        transition: .8s;
        

        img{
          max-width: 100%;
          max-height: 100%;
          display: inline-block;
         
        }
      }

      .titulo{
        text-transform: uppercase;
        margin-bottom: 0px;
        transform: translateY(300px);
        opacity: 0;
        transition: .8s;
        transition-delay: .4s;
      }

      p{
        font-size: 20px;
        line-height: 30px;
        text-align: center;
        width: 100%;
        transform: translateY(300px);
        opacity: 0;
        transition: .8s;
        transition-delay: .8s;
      }

    }


    &.launched{
      .contenedor-imagen,.titulo,p{
        opacity: 1;
        transform: translateY(0);
      }
    }
  }


  @media screen and (max-width: 769px){
    .title.-ghost{
      display: none;
    }
  }

   @media screen and (max-width: 700px){
    .banner-denominacion .denominacion p{
      font-size: 14px;
    }

    p{
      font-size: 16px;
    }
  }
@media screen and (max-width: 650px){
    .banner-denominacion{
      height: 200px;
    }
  }
  @media screen and (max-width: 380px){
    .banner-denominacion{
      height: 150px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/productos/banner-denominacion.vue